import { DefaultButton, Icon, IconButton, Label, PrimaryButton, Stack } from '@fluentui/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { _renderRow } from '../../control/function/detailList';
import * as Api from '../../api/src';
import '../../css/components/test.scss';
import useToken from '../account/login/useToken';
import { DialogContext } from '../../context/dialog.context';
import { commonfn, TestService } from '../../common/commonfn';
import ModalTest from './modal/modalTest';
import moment from 'moment';
import { FileTypeAccept, RoleName } from '../../common/constant/constantKey';
import ModalUnApproveTest from './modal/modalUnApproveTest';
import globalData from '../../common/globalData';
import DocumentViewer from '../../control/DocumentViewer';
import { saveAs } from 'file-saver';

const TestsApi = new Api.TestsApi();
const TestDocumentsApi = new Api.TestDocumentsApi();
const DocumentsApi = new Api.DocumentsApi();

interface GeneralProps {
  Item: Api.TestDto;
  isView?: boolean;
  RefeshTab: (id?: number) => void;
}
const General = ({ Item, isView, RefeshTab }: GeneralProps) => {
  const { userTokenInfo } = useToken();
  const { t } = useTranslation();
  const [isOpenModalUnApprove, SetIsOpenModalUnApprove] = React.useState(false);
  const [listDocument, SetListDocument] = React.useState<Api.DocumentDto[]>();
  const [test, SetTest] = React.useState<Api.TestDto>({});
  const [isOpenModal, SetIsOpenModal] = React.useState(false);
  const [isOpenDocument, SetIsOpenDocument] = React.useState(false);
  const [documentFile, SetDocumentFile] = React.useState<any>();
  const { setMsgConfirmDialog, setCallBackConfirmDialog } = React.useContext(DialogContext);
  const role = userTokenInfo['Role'].toString().toLocaleUpperCase();
  React.useEffect(() => {
    getListDoccment();
    TestsApi.apiTestsIdGet(Item.Id || 0).then((o) => {
      SetTest(o.data.Data || {});
    });
  }, [Item]);
  const getTestStatus = (item: Api.Test) => {
    let status = commonfn.getTestStatus(item);
    let iconName = 'CircleHalfFull';
    if (status === Api.TestStatusQueryEnum.Approved) {
      iconName = 'SkypeCircleCheck';
    }
    return (
      <>
        <Icon iconName={iconName} className={status} style={{}}></Icon>&nbsp; <span>{t(status)}</span>
      </>
    );
  };
  const getPerson = (name: string, date: string) => {
    if (name) {
      return name + ' ' + t('On') + ' ' + moment(date).format('DD/MM/yyyy hh:mm');
    }
    return '-';
  };
  const getListDoccment = () => {
    if (!Item.Id) return;
    TestDocumentsApi.apiTestDocumentsIdGet(Item.Id || 0).then((o) => {
      if (o.data) {
        SetListDocument(o.data.Data || []);
      }
    });
  };

  const handleOnChange = (e: any) => {
    if (!Item.Id) return;
    const formData = new FormData();
    for (let index = 0; index < e.target.files.length; index++) {
      const element = e.target.files[index];
      formData.append('documents ', element);
    }
    TestDocumentsApi.apiTestDocumentsIdPost(Item.Id || 0, formData as any).then(() => {
      getListDoccment();
      let a = document.getElementById('uploadFile') as any;
      a['value'] = '';
    });
  };

  const deleteItem = (docId: number) => {
    if (!Item.Id) return;
    setMsgConfirmDialog(t('AreYouSureYouWantToDeleteThisData'));
    setCallBackConfirmDialog({
      action: (testId: number) => {
        TestDocumentsApi.apiTestDocumentsIdDelete(testId, [docId]).then(() => {
          getListDoccment();
        });
      },
      param: Item.Id,
    });
  };
  const downloadItem = (Item: Api.Document, preview?: boolean) => {
    if (preview) {
      if (Item.Name?.toLowerCase().indexOf('.pdf')) {
        window.open(process.env.REACT_APP_API_ENDPOINT + '/api/Documents/' + Item.Id + '/' + Item.Name, '_blank');
      } else {
        SetDocumentFile(Item);
        SetIsOpenDocument(true);
        return;
      }
    }
    if (!Item.Id) return;
    DocumentsApi.apiDocumentsIdGet(Item.Id || 0, {
      responseType: 'blob',
    }).then((response) => {
      const rs = response as any;
      saveAs((response as any).data as Blob, `${Item.Name}`);
    });
  };
  const ApproveItem = async (id: number) => {
    if (globalData.Configurations?.ModuleFollowTestApproved === Api.ModuleFollowTestApprovedEnum.NotApplicable) {
      await TestsApi.apiTestsIdSetApprovedPatch(id, true, false);
      RefeshTab(Item.Id);
    } else {
      setMsgConfirmDialog(t('AreYouSureYouWantToApproveThisTest'));
      setCallBackConfirmDialog({
        action: async () => {
          await TestsApi.apiTestsIdSetApprovedPatch(id, true, true);
          RefeshTab(Item.Id);
        },
        param: id,
      });
    }
  };
  return (
    <div className="test-detail margin-left-0 margin-right-0 page-content">
      <div className="ms-Grid padding-right-0" dir="ltr">
        <div className="display-flex">
          {!isView && (
            <Stack horizontal className="header-action margin-left-auto">
              {!TestService.allowApproveTest(test) && role && role != RoleName.VENDOR && (
                <>
                  &nbsp; &nbsp;
                  <PrimaryButton
                    text={t('UnApprove')}
                    className={''}
                    disabled={TestService.isExpired(test)}
                    onClick={() => {
                      SetIsOpenModalUnApprove(true);
                    }}
                  />
                </>
              )}
              {TestService.allowApproveTest(test) && role && role != RoleName.VENDOR && (
                <>
                  &nbsp; &nbsp;
                  <PrimaryButton
                    text={t('Approve')}
                    className={''}
                    disabled={TestService.isExpired(test)}
                    onClick={() => {
                      ApproveItem(test.Id || 0);
                    }}
                  />
                </>
              )}

              {TestService.allowEditTest(test) && (
                <>
                  &nbsp; &nbsp;
                  <DefaultButton
                    text={t('Edit')}
                    onClick={() => {
                      SetIsOpenModal(true);
                    }}
                  ></DefaultButton>
                </>
              )}
            </Stack>
          )}
        </div>
        <div className="ms-Grid-row">
          <div className="label ms-Grid-col">
            <Label>{t('TestName')}</Label>
          </div>
          <div className="ms-Grid-col">{test.Name || '-'}</div>
        </div>
        <div className="ms-Grid-row">
          <div className="label ms-Grid-col">
            <Label>{t('Status')}</Label>
          </div>
          <div className="flex-center ms-Grid-col">{getTestStatus(test)}</div>
        </div>
        <div className="ms-Grid-row display-flex">
          <div className="label ms-Grid-col">
            <Label>{t('Description')}</Label>
          </div>
          <div className="ms-Grid-col">{test.Description || '-'}</div>
        </div>
        <div className="ms-Grid-row">
          <div className="label ms-Grid-col">
            <Label>{t('CreatedBy')}</Label>
          </div>
          <div className="ms-Grid-col">{getPerson(test.CreateBy?.FullName || '', test.CreatedOn || '')}</div>
        </div>
        <div className="ms-Grid-row">
          <div className="label ms-Grid-col">
            <Label>{t('LastUpdated')}</Label>
          </div>
          <div className="ms-Grid-col">{getPerson(test.LastUpdateBy?.FullName || '', test.LastModifiedOn || '')}</div>
        </div>
        <div className="ms-Grid-row">
          <div className="label ms-Grid-col">
            <Label>{t('ApprovedBy')}</Label>
          </div>
          <div className="ms-Grid-col">{test.IsApproved || false ? test.ApprovedBy?.FullName : '-'}</div>
        </div>
        <div className="ms-Grid-row">
          <div className="label ms-Grid-col">
            <Label>{t('ProductType')}</Label>
          </div>
          <div className="ms-Grid-col">{test.ProductType?.Name || '-'}</div>
        </div>
        <div className="ms-Grid-row">
          <div className="label ms-Grid-col">
            <Label>{t('ProductVendor')}</Label>
          </div>
          <div className="ms-Grid-col">{test.Vendor?.Name || '-'}</div>
        </div>
        <div className="ms-Grid-row">
          <div className="label ms-Grid-col">
            <Label>{t('Component')}</Label>
          </div>
          <div className="ms-Grid-col">{test.Component?.Name || '-'}</div>
        </div>
        <div className="ms-Grid-row">
          <div className="label ms-Grid-col">
            <Label>{t('Brand')}</Label>
          </div>
          <div className="ms-Grid-col">{test.ComponentModel?.CBrand?.Name || '-'}</div>
        </div>
        <div className="ms-Grid-row">
          <div className="label ms-Grid-col">
            <Label>{t('ComponentModel')}</Label>
          </div>
          <div className="ms-Grid-col">{test.ComponentModel?.Name || '-'}</div>
        </div>
        <div className="ms-Grid-row">
          <div className="label ms-Grid-col">
            <Label>{t('TestDate')}</Label>
          </div>
          <div className="ms-Grid-col">{moment(test.TestDate).format('DD/MM/yyyy') || '-'}</div>
        </div>
        <div className="ms-Grid-row">
          <div className="label ms-Grid-col">
            <Label>{t('ExpiredDate')}</Label>
          </div>
          <div className="ms-Grid-col">{moment(test.ExpiredDate).format('DD/MM/yyyy') || '-'}</div>
        </div>
        <div className="ms-Grid-row test-documents">
          <div className="label ms-Grid-col ">
            <Label>{t('TestReportDocuments')}</Label>
          </div>
          <div className={'list'}>
            <div className="ms-Grid-row">
              <table style={{ marginBottom: 15 }} className={'ms-md12'}>
                <tbody>
                  {listDocument?.map((o) => {
                    return (
                      <tr key={o.Id} className={'flex-center'}>
                        <td style={{ width: 80 }} className={'ms-md7 flex-center'}>
                          {!isView && (
                            <IconButton
                              className={'delete'}
                              iconProps={{ iconName: 'Delete' }}
                              onClick={() => {
                                deleteItem(o.Id || 0);
                              }}
                            ></IconButton>
                          )}
                          <IconButton
                            className={'CloudDownload'}
                            iconProps={{ iconName: 'CloudDownload' }}
                            onClick={() => {
                              downloadItem(o);
                            }}
                          ></IconButton>
                          <Icon iconName={'Attach'}></Icon>
                        </td>

                        <td className={'ms-md7 flex-center'}>
                          <div>
                            <a
                              onClick={() => {
                                downloadItem(o, true);
                              }}
                            >
                              {o.Name}
                            </a>
                          </div>
                        </td>
                        <td className={'ms-md5 flex-center'}>
                          <span>{t('UploadBy') + ' ' + getPerson(o.CreateBy?.FullName || '', o.CreatedOn || '')}</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {!listDocument?.length ? <div className="noDocuments">{t('NoDocuments')}</div> : ''}
            </div>
            {!isView && (
              <>
                <DefaultButton
                  text={t('UploadDocuments')}
                  iconProps={{ iconName: 'CloudUpload' }}
                  onClick={() => {
                    let a = document.getElementById('uploadFile');
                    if (a) {
                      a.click();
                    }
                  }}
                ></DefaultButton>
                <input
                  id="uploadFile"
                  multiple
                  accept={FileTypeAccept.FileAcceptTests}
                  style={{ display: 'none' }}
                  type="file"
                  onChange={handleOnChange}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <ModalUnApproveTest
        IsOpen={isOpenModalUnApprove}
        Item={test}
        onSaveClick={() => {
          RefeshTab(test.Id);
        }}
        onCloseModal={() => {
          SetIsOpenModalUnApprove(false);
        }}
      ></ModalUnApproveTest>
      <ModalTest
        productypeId={null}
        IsOpen={isOpenModal}
        Item={test}
        onSaveClick={() => {
          RefeshTab(test.Id);
        }}
        onCloseModal={() => {
          SetIsOpenModal(false);
        }}
      ></ModalTest>
      {isOpenDocument && (
        <DocumentViewer
          Item={documentFile}
          IsOpen={isOpenDocument}
          onCloseModal={() => {
            SetIsOpenDocument(false);
          }}
        ></DocumentViewer>
      )}
    </div>
  );
};
export default General;
